export function jsonStringify(val: unknown): string {
  if (val === undefined || val === null) return '{}';
  return JSON.stringify(val, null, 2);
}

export function hasContent(json: string): boolean {
  try {
    const parsed = JSON.parse(json) as unknown;
    return typeof parsed === 'object' && parsed !== null && Object.keys(parsed as object).length > 0;
  } catch {
    return false;
  }
}

export function checkJsonChanged(jsonA: string, jsonB: string): boolean {
  try {
    const parsedA = JSON.parse(jsonA);
    const parsedB = JSON.parse(jsonB);
    return JSON.stringify(parsedA) !== JSON.stringify(parsedB);
  } catch {
    return jsonA.trim() !== jsonB.trim();
  }
}
